module.exports = __webpack_public_path__ + "media/images/university_logos/Durham-University-e67a0e8db3e5efe94699f68b659fb5bf.svg";